import React from "react";
import { Fab, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function PATCloseButton(props) {
  const { onClick, disabled, size, styles, tooltipText } = props;

  return (
    <Tooltip title={tooltipText || "Close"}>
      <Fab
        size="small"
        disabled={disabled}
        color="secondary"
        style={styles}
        aria-label="close"
        className={props.className ? props.className : ""}
        onClick={onClick}
      >
        <CloseIcon style={{ fontSize: size }} />
      </Fab>
    </Tooltip>
  );
}
